import { atom } from 'recoil';
import { defaultSettings } from '../../../config';
import { colorPresets } from '../../../utils/getColorPresets';
import { localStorageEffect } from '../../../utils/localStorageEffect';

export const settingsState = atom({
  key: 'settingsState',
  default: {
    ...defaultSettings,
    colorOption: colorPresets.map((color) => ({
      name: color.name,
      value: color.main,
    })),
  },
  effects: [
    localStorageEffect({
      key: 'settingsState',
      restorer: (value, defaultValue) => {
        if (value === null) {
          return defaultValue;
        }

        if (typeof value === 'object') {
          return value;
        }

        return defaultValue;
      },
    }),
  ],
});
